import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';
import TextBase from '@components/common/core/DataDisplay/Text';
import TextFieldBase from '@components/common/core/Inputs/TextField';

export const ProfilesQuantity = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[1]};
  font-size: 0.875rem;
`;

export const AddProfileAndQuantityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  width: 267px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Heading = styled(HeadingBase)`
  font-size: 1.75rem;
`;

export const Text = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[2]};
`;

export const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media only screen and (max-width: 1260px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 24px;
  }

  @media only screen and (max-width: 1024px) {
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  @media only screen and (max-width: 950px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 24px;
  }
`;

export const SyncAndInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 1260px) {
    flex-direction: row-reverse;
  }

  @media only screen and (max-width: 1024px) {
    flex-direction: row;
  }

  @media only screen and (max-width: 950px) {
    flex-direction: row-reverse;
  }
`;

export const AddNewProfileButton = styled.button`
  padding: 18px 16px;
  background-color: ${({ theme }) => theme.colors.gray[6]};
  border-radius: 5px;
  height: 60px;
  /* font-family: 'Poppins'; */
  font-family: 'Mukta';
  font-weight: 400;
  font-size: 1rem;
  border: 0;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[1]};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }
`;

export const VerticalRule = styled.div`
  height: calc(100% + 36px);
  width: 2px;
  background-color: ${({ theme }) => theme.colors.gray[4]};
  margin-left: 22px;
`;

export const LastUpdatedText = styled(TextBase)`
  width: 100%;
  max-width: 149px;
  color: ${({ theme }) => theme.colors.gray[2]};
`;

export const SyncDataButton = styled.button`
  height: 42px;
  margin-right: 12px;
  margin-left: 16px;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.gray[6]};
  border-radius: 6px;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }
`;

export const Input = styled(TextFieldBase)`
  width: 100%;
  min-width: 385px;

  @media only screen and (max-width: 625px) {
    min-width: unset;
  }

  & > div > input {
    color: ${({ theme }) => theme.colors.gray[3]};
  }

  & > div {
    background-color: ${({ theme }) => theme.colors.gray[6]};
  }
`;
